import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AdminServiceNew } from '../services/admin-new.service';
import { Auth0Service } from '../services/auth0.service';
import { map, switchMap, timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  CHANGE_INITIAL_PASSWORD,
  LOGIN_PATH,
} from '../../../../apps/values/path';

export const HasChangedInitialPasswordAdmin: CanActivateFn = (route, state) => {
  const ROUTER = inject(Router);
  const auth0Service = inject(Auth0Service);
  const adminService = inject(AdminServiceNew);

  return auth0Service.user$.pipe(
    switchMap((user) => {
      if (!user?.sub) {
        return of(ROUTER.createUrlTree([`/${LOGIN_PATH}`]));
      }

      return adminService.getAdminProfile(user.sub).pipe(
        timeout(5000), // 5 second timeout
        map((adminProfile) => {
          if (
            adminProfile &&
            adminProfile.has_changed_initial_password === false
          ) {
            return ROUTER.createUrlTree([`/${CHANGE_INITIAL_PASSWORD}`]);
          }
          return true;
        }),
        catchError((error) => {
          // On error, redirect to login for safety
          return of(ROUTER.createUrlTree([`/${LOGIN_PATH}`]));
        })
      );
    })
  );
};
